const SHORT_CRITICAL_SESSION_EXPIRED = 'SHORT SESSION AUTHENTICATION EXPIRED'
const AUTH_TOKEN_NOT_PRESENT = 'NO AUTH TOKEN. AUTHENTICATION FAILED'

module.exports = {
  SHORT_CRITICAL_SESSION_EXPIRED,
  AUTH_TOKEN_NOT_PRESENT,
}
